import styled from 'styled-components';
export const Divider = styled.hr `
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  border-top: var(--border-b-seed) solid var(--base-border-secondary);
  margin: ${({ spacing }) => spacing || `var(--layout-soybean)`} var(--layout-sandgrain);
`;
